'use client';

import { Card, PageContainer } from '@/components';
import { Button, Separator } from '@mokoboko/components';
import ChevronDown from '@/icons/chevron-down';
import { GiftCards as GiftCardsList } from '@/components/features/gift-cards';
import { useGoBack } from '@/hooks/use-go-back';
import { useIsMobile } from '@/hooks/use-is-mobile';

const GiftCards = () => {
  const { goBack } = useGoBack();
  const isMobile = useIsMobile();

  return (
    <PageContainer>
      <Card contentClassName="p-5 flex flex-col gap-4 sm:gap-5">
        <Button
          variant="secondary-gray"
          className="w-fit"
          leadingIcon={<ChevronDown rotate={90} />}
          onClick={() => goBack()}
          size={isMobile ? 'lg' : 'md'}
        >
          Go back
        </Button>
        <Separator />
        <GiftCardsList headingAs="h1" />
      </Card>
    </PageContainer>
  );
};

export default GiftCards;
